import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { 
  InterventionInput, 
  FertilizerInput, 
  StabilizedFertilizerInput,
  ControlledReleaseFertilizerInput,
  FuelInput
} from "../../types";

// Import response type
interface ImportResponse {
  successful_imports: number;
  failed_imports: number;
  errors?: string[];
}

export const interventionInputApi = createApi({
  reducerPath: "interventionInputApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/is/intervention_input",
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["InterventionInput"],
  endpoints: (build) => ({
    getInterventionInputs: build.query<InterventionInput[], void>({
      query: () => "",
      providesTags: ["InterventionInput"],
    }),
    getInterventionInput: build.query<InterventionInput, string>({
      query: (id) => `/${id}`,
      providesTags: ["InterventionInput"],
    }),
    addInterventionInput: build.mutation<InterventionInput, Partial<InterventionInput>>({
      query(body) {
        return {
          url: ``,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["InterventionInput"],
    }),
    updateInterventionInput: build.mutation<InterventionInput, { id: string; body: Partial<InterventionInput> }>({
      query({ id, body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["InterventionInput"],
    }),
    deleteInterventionInput: build.mutation<void, string>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["InterventionInput"],
    }),
    importInterventionInputs: build.mutation<ImportResponse, FormData>({
      query(formData) {
        return {
          url: '/import',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['InterventionInput'],
    }),
}),
});

export const {
  useGetInterventionInputsQuery,
  useGetInterventionInputQuery,
  useAddInterventionInputMutation,
  useUpdateInterventionInputMutation,
  useDeleteInterventionInputMutation,
  useImportInterventionInputsMutation,
} = interventionInputApi;